/***
 * @Author: ZhaoG
 * @Date: 2025-05-08 17:43:15
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-08 17:52:53
 * @FilePath: \gcp-fe\src\app\shop\utils\utils.js
 * @Description: 时间格式化 计算剩余时间格式化功能
 */

// 日期解析方法（保持通用性）
export function parseDateTime(dateTimeStr) {
  try {
    const [datePart, timePart] = dateTimeStr.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes] = (timePart || "00:00").split(":").map(Number);
    return new Date(year, month - 1, day, hours, minutes);
  } catch (e) {
    throw new Error(`无效的日期格式: ${dateTimeStr}`);
  }
}

// 剩余时间计算方法（精确到分钟）
export function calculateRemainingTime(endTime) {
  try {
    const end = parseDateTime(endTime);
    const now = new Date();
    let diff = end - now;

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0 };
    }

    diff = Math.floor(diff / 1000); // 转换为秒
    const days = Math.floor(diff / (3600 * 24));
    diff = diff % (3600 * 24);
    const hours = Math.floor(diff / 3600);
    diff = diff % 3600;
    const minutes = Math.floor(diff / 60) + 1;

    return { days, hours, minutes };
  } catch (e) {
    console.error("时间计算错误:", e.message);
    return { days: 0, hours: 0, minutes: 0 };
  }
}
